import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-documentapproval',
  templateUrl: './documentapproval.component.html',
  styleUrls: ['./documentapproval.component.css']
})
export class DocumentapprovalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/dashboard/dashboardwidgets/documentapproval/documentapproval.component.ts